import { render, staticRenderFns } from "./ProfileUnique.vue?vue&type=template&id=49f62f00&"
import script from "./ProfileUnique.vue?vue&type=script&lang=js&"
export * from "./ProfileUnique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports